import { render } from "./UploadButton.vue?vue&type=template&id=0f785a4c"
import script from "./UploadButton.vue?vue&type=script&lang=ts"
export * from "./UploadButton.vue?vue&type=script&lang=ts"

import "./UploadButton.vue?vue&type=style&index=0&id=0f785a4c&lang=less"
script.render = render

export default script